<app-data-list-command
    [hidefilter]="true"
    [hideReload]="true"
    (filtersToApplyChange)="searchLogs($event.criteria)"
    data-testid="cipo-access-log-tab">
    <div cipoCommandContent class="cipo--height--full">
        <cipo-paged-data-list
            class="cipo--height--full"
            fxLayout="column"
            fxLayoutAlign="space-between"
            [options]="tableOptions()"
            [tableData]="tableData()"
            [tableColumns]="tableColumns()"
            (paginationUpdated)="handlePagination($event)"
            (sortChanged)="handleSort($event)" />
    </div>
</app-data-list-command>
